import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

import Navbar from "@/features/public/components/Navbar.vue";
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { MainContainer } from "@/models/MainContainer";
import { Profile } from "@/models/Profile";

interface ListItem {
  name: string;
  link: string;
  icon: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutPublic',
  setup(__props) {

const containerByDNS = ref<Profile>(null);
const store = useStore();

const isLoaded = ref(false);

const listItems: ListItem[] = [
  // {
  //   name: "Partner",
  //   link: "/positions",
  //   icon: "fas fa-handshake",
  // },
  // {
  //   name: "Karriär",
  //   link: "/positions",
  //   icon: "fas fa-briefcase",
  // },
  // {
  //   name: "Om oss",
  //   link: "/positions",
  //   icon: "fas fa-info-circle",
  // },
  // {
  //   name: "Kontakt",
  //   link: "/positions",
  //   icon: "fas fa-phone",
  // },
];

const renderContainerByDNS = ref(false);
onMounted(async () => {
  if (store.getters.publicContainer.id === undefined) {
    await store.dispatch("loadPublicContainerByName", "");
  }

  if (store.getters.publicContainer.id === 0) {
    renderContainerByDNS.value = false;
  } else {
    renderContainerByDNS.value = true;
  }
  isLoaded.value = true;
});

onMounted(async () => {
  await store.dispatch("loadContainerTheme");
  try {
    await store.dispatch("loadContainerTheme");
    containerByDNS.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
    // isLoaded.value = true;
  } catch (error) {
    console.error("Error loading public container:", error);
  }
});

// const test = ref('#FFB6C180');
const themedBackground = computed(
  () => store.getters.getContainerThemedBackground
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("link", {
      href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css",
      rel: "stylesheet"
    }, null, -1)),
    (isLoaded.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle({ background: themedBackground.value?.mainContent })
        }, [
          (!renderContainerByDNS.value)
            ? (_openBlock(), _createBlock(Navbar, {
                key: 0,
                "list-items": listItems
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["sm:mt-0", renderContainerByDNS.value ? 'mt-0' : 'mt-[60px]'])
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2)
        ], 4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})